import { getResponseQuery } from "@helpers/_functions";

import http from "../../http-common";
import BaseService from "../base.service";

class SurveySubjectService extends BaseService {
  constructor() {
    super("survey-subjects");
  }

  insertMany(surveySubjects) {
    return getResponseQuery(
      http.post(`${this.path}/create-many`, surveySubjects)
    );
  }

  updateMany(surveySubjects) {
    return getResponseQuery(
      http.post(`${this.path}/update-many`, surveySubjects)
    );
  }

  duplicateOne(surveySubjectId) {
    return getResponseQuery(
      http.post(`${this.path}/duplicate/${surveySubjectId}`)
    );
  }

  deleteMany(surveySubjects) {
    return getResponseQuery(
      http.post(`${this.path}/delete-many`, surveySubjects)
    );
  }
}

export default new SurveySubjectService();
